// src/layouts/SISLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import SISSidebar from "../components/SISSidebar";
import SchoolHeader from "../components/SchoolHeader";
import Navbar from "../components/Navbar";

export default function SISLayout({ user, setUser }) {
  const primary = String(user?.role || "").toLowerCase();
  const extras = Array.isArray(user?.roles) ? user.roles.map(r => String(r).toLowerCase()) : [];
  const roles = [primary, ...extras].filter(Boolean);
  const encoderOnly = roles.includes("encoder") && !roles.some(r => ["admin", "superadmin", "registrar", "finance"].includes(r));
  return (
    <div className="sis-layout" style={{ minHeight: "100vh", display: "flex" }}>
      <SISSidebar />
      <div style={{ flexGrow: 1, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <SchoolHeader />
        {/* Header */}
        <header className="sis-header" style={{ padding: "18px 24px", background: "var(--theme-bg)", borderBottom: "1px solid var(--theme-border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <i className="bi bi-mortarboard" style={{ fontSize: 24, color: "var(--theme-primary)" }}></i>
            <h5 style={{ margin: 0 }}>Student Information System</h5>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ color: "#6c757d" }}>
              {user ? user.username : "Guest"}
            </span>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                localStorage.removeItem("user");
                window.location.href = "/login";
              }}
            >
              Logout
            </button>
          </div>
        </header>
        {!encoderOnly && <Navbar />}
        {/* Main content area */}
        <main className="sis-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
